import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from 'apollo-boost';
import { WebSocketLink } from 'apollo-link-ws';
import { getMainDefinition } from 'apollo-utilities';
import { onError } from 'apollo-link-error';
import { setContext } from 'apollo-link-context';
import { split } from 'apollo-link';
import { environment } from '../environments/environment';

const BASE_URL = environment.REACT_APP_BASE_URL;
const WEBSOCKET_URL = environment.REACT_APP_GRAPHQL_WS;

export const getClient = (authToken: string) => {

  const httpLink = new HttpLink({
    uri: `${BASE_URL}/graphql`,
  });

  const wsLink = new WebSocketLink({
    uri: `${WEBSOCKET_URL}`,
    options: {
      connectionParams: {
        'access-token': authToken,
      },
      lazy: true,
      reconnect: false,
    },
  });

  const cache = new InMemoryCache();
  const authLink = setContext(async (_, { headers }) => {
    const token = authToken;
    return {
      headers: {
        ...headers,
        'access-token': token,
      },
    };
  });

  const httpAuthLink = authLink.concat(httpLink);

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.map(({ message, locations, path }) =>

        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
        ),
      );
    }

    if (networkError) console.log(`[Network error]: ${JSON.stringify(networkError)}`);
  });

  const link = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
      );
    },
    wsLink,
    httpAuthLink,
  );

  const client = new ApolloClient({
    link: ApolloLink.from([
      errorLink,
      link,
    ]),
    cache,
  });
  return client;
};